import React from "react";
import styles from "./Footer.module.css";

const version = process.env.REACT_APP_VERSION;

const Footer = () => {
    return (
        <>
            <div className={styles.footerPlaceholder}></div>
            <footer className={styles.footer}>
                <span title={version}>&copy;&nbsp;{new Date().getFullYear()}&nbsp;DDM Consulting&nbsp;-&nbsp;version&nbsp;{version}</span>
            </footer>   
        </>
    )
}

export default Footer;